module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-12-60262142d9903dfe376fd0d5a764e63a.jpg";